// extracted by mini-css-extract-plugin
module.exports = {"title":"Bumper_title__BEejb","description":"Bumper_description__NcnE2","link":"Bumper_link__FLnJr"};